type CourierId = 'DHL' | 'UPS' | undefined

export interface Courier {
    enabled?: boolean
    blockList?: string[]
    blockListForNonEIPNorVIP?: string[]
}

interface ExtendedCourier extends Courier {
    bookACollectionEnabled: boolean
}

interface CollectionService {
    couriers?: {
        DHL?: Courier
        UPS?: Courier
    }
}

const getCourierFromTrackingUrl = (returnTrackingUrl: string): CourierId => {
    if (returnTrackingUrl?.includes('dhl.com')) return 'DHL'
    if (returnTrackingUrl?.includes('ups.com')) return 'UPS'
    return undefined
}

const isCourierAvailableOnCountry = (courier: Courier, shippingCountry: string, isRegularUser: boolean): boolean => {
    const { blockList = [], blockListForNonEIPNorVIP = [] } = courier

    return (
        !blockList.includes(shippingCountry) &&
        (!isRegularUser || (isRegularUser && !blockListForNonEIPNorVIP.includes(shippingCountry)))
    )
}

const getCourierFromCollectionService = (
    courierId: CourierId,
    collectionService: CollectionService = {},
    shippingCountry: string,
    isRegularUser: boolean // meaning non EIP for NAP & MRP and non VIP for TON
): ExtendedCourier | undefined => {
    if (courierId) {
        const courier = collectionService.couriers?.[courierId]
        if (courier) {
            return {
                ...courier,
                bookACollectionEnabled:
                    Boolean(courier?.enabled) &&
                    isCourierAvailableOnCountry(courier, shippingCountry, isRegularUser),
            }
        }
    }
    return undefined
}
export { getCourierFromTrackingUrl, isCourierAvailableOnCountry, getCourierFromCollectionService }
